import type { Reducer } from 'redux';
import { AppChromeState, packageStateKey } from './state';

export { default as App } from './components/app/app';
export * from './actions/user/leftNavActions';
export * from './actions/user/groupManagementActions';
export * from './actions/user/folderManagementActions';
export * from './actions/data/folderManagementDataActions';

export const appChromePackageStateKey = packageStateKey;

export function getAppChromeStateReducer(): Promise<Reducer<AppChromeState>> {
    // We dynamically import the reducer to avoid circular dependencies when other packages import from this package
    return import(
        /* webpackChunkName: "AppChromeReducer", webpackMode: "eager" */ './reducers/appChromeReducer'
    ).then(reducerImport => {
        return reducerImport.default;
    });
}
